const prod = {
    url: {
     API_URL: 'https://vp-api.blinkay.app/api/zoneoptions'          //Canada API
    //  API_URL: 'https://vp-usa-api.blinkay.app:444/api/zoneoptions'  //USA API   
    }
};
const dev = {
    url: {
    //  API_URL: 'https://vp-api.blinkay.app/api/zoneoptions'     
    //  API_URL: 'https://vp-api.blinkay.app/api/zoneoptions'     
     API_URL: 'http://localhost:3003'
    }
};

export const config = process.env.NODE_ENV === "development" ? dev : prod;